import script from "./paymentresponse.vue?vue&type=script&setup=true&lang=js"
export * from "./paymentresponse.vue?vue&type=script&setup=true&lang=js"

import "./paymentresponse.vue?vue&type=style&index=0&id=42255c84&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42255c84"]])

export default __exports__